import * as Scrivito from "scrivito";
import MainNavigationLink from "./MainNavigationLink";

function MainNavigationItem({ child, className }) {
  if (!child) {
    return null;
  }
  if (child.get("hideInNavigation") === "yes") {
    return null;
  }
  return (
    <li className={className}>
      <MainNavigationLink child={child} />
    </li>
  );
}

export default Scrivito.connect(MainNavigationItem);
